import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { dev } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import { Shell } from "../components/Shell";

/** Community is a later phase (design v2 order 5); this is the door. */
export function Community() {
  return (
    <Shell brand active="Community" title="Community" right={<span />}>
      <div className="p center" style={{ paddingTop: "clamp(120px, 26vh, 220px)", maxWidth: 560 }}>
        <h1>Moments are coming.</h1>
        <p className="sub mt16">Publish a clip and its number, watch others', like and report. Not yet built.</p>
        <div className="mt32"><Link className="btn ghost wide" to="/">Back to videos</Link></div>
      </div>
    </Shell>
  );
}

export function BillingResult({ ok }: { ok: boolean }) {
  const { refresh, plan } = useAuth();
  const [params] = useSearchParams();
  const [fresh, setFresh] = useState(false);
  useEffect(() => { void refresh().finally(() => setFresh(true)); }, [refresh]);
  if (!fresh) return <Shell title="Plans" back="/" right={<span />}><div className="p tiny mt24">Checking your plan…</div></Shell>;
  // The success URL names the plan bought: Stripe can redirect here before its webhook has switched the account's plan.
  const bought = params.get("plan");
  const now = bought === "pro" || bought === "basic" ? bought : plan;
  const pro = ok && now === "pro";
  return (
    <Shell title="Plans" back="/" right={<span />}>
      <div className="p center" style={{ paddingTop: "clamp(120px, 26vh, 220px)", maxWidth: 560 }} data-testid="billing-result">
        <h1>{!ok ? "No change." : pro ? "Welcome to Pro." : "You're on " + (now === "basic" ? "Basic" : "your new plan") + "."}</h1>
        <p className="sub mt16" style={{ textWrap: "balance" }}>{!ok ? "The checkout was cancelled. Your plan is unchanged." : pro ? "You've joined an elite group of members who analyse the game at the next level." : "Clips by player are unlocked on every ready video."}</p>
        <div className="mt32"><Link className="btn dark wide" to="/">Back to videos</Link></div>
      </div>
    </Shell>
  );
}

/** Stripe Checkout stand-in (dev backend only): "pay" posts a signed webhook to the real handler. */
export function DevCheckout() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const sub = params.get("sub") ?? "";
  const plan = params.get("plan") ?? "";
  const pay = async () => {
    setBusy(true);
    try {
      const r = await dev.completeCheckout(sub);
      if (r.webhook_status !== 200) throw new Error(`webhook answered ${r.webhook_status}`);
      nav(`/billing/success?plan=${encodeURIComponent(plan)}`, { replace: true });
    } catch (e) {
      setErr((e as Error).message);
      setBusy(false);
    }
  };
  if (!dev.enabled) return <Shell><div className="p mt24">Not available.</div></Shell>;
  return (
    <Shell title="Checkout (placeholder)" back="/plans" right={<span />}>
      <div className="p" style={{ paddingTop: 24, maxWidth: 480 }} data-testid="dev-checkout">
        <div className="cap">Stripe Checkout stand-in</div>
        <h1 className="mt10">Pay for {plan || "the plan"}.</h1>
        <p className="sub mt10">No Stripe account is wired. Paying here sends a signed <code>checkout.session.completed</code> webhook to the real API handler, which activates the subscription.</p>
        <div className="mt24"><button className="btn dark full" onClick={pay} disabled={busy || !sub} data-testid="dev-pay">Simulate payment</button></div>
        <div className="mt10"><button className="btn ghost full" onClick={() => nav("/billing/cancel")}>Cancel</button></div>
        {err ? <p className="err mt10">{err}</p> : null}
      </div>
    </Shell>
  );
}
